import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of, filter } from 'rxjs';
import {
  catchError,
  map,
  mergeMap,
  withLatestFrom,
} from 'rxjs/operators';
import { Store } from '@ngrx/store';

import {
  TIP_FIND,
  TIP_FIND_SUCCESS,
  TIP_FAILED,
  TIP_UPDATE_LOADING,
  TIP_FIND_ALL_SUCCESS,
  TIP_DETAIL_FIND_SUCCESS,
 } from '@store/actions'

import { TipService } from '@core/services';
import { selectLocalChannelId } from '../selectors';
import { Tip } from '@core/models';
import { transformTipListData } from '@core/helpers';

@Injectable()
export class TipEffects {
  localChannelId$: Observable<string | null>;

  constructor(
    private actions$: Actions,
    private tipService: TipService,
    private store: Store,
  ) {
    this.localChannelId$ = this.store.select(selectLocalChannelId)
  }

  find$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TIP_FIND),
      withLatestFrom(
        this.store.select(selectLocalChannelId)
      ),
      filter(([_, localChannelId]) => !!localChannelId),
      map(([_, localChannelId]) => {
        return { localChannelId: localChannelId as string }
      }),

      mergeMap(({ localChannelId }) => {
        this.store.dispatch(TIP_UPDATE_LOADING({ loading: true }));
        return this.tipService.find(localChannelId).pipe(
          mergeMap(({ data }) => {
            const tipList = data as Tip[];
            const tipChannel = transformTipListData(tipList);

            return [
              TIP_UPDATE_LOADING({ loading: false }),
              TIP_FIND_ALL_SUCCESS({ tipList }),
              TIP_FIND_SUCCESS({ tip: tipChannel }),
              TIP_DETAIL_FIND_SUCCESS({ tipDetail: null })
            ];
          }),
          catchError((error) => of(TIP_FAILED({
            error: error.error?.message || 'Error loading order types',
          })))
        );
      })
    )
  );
}
